// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","dialogRoot":"_2OjpQs6G0aRr","root":"jbB0LBYwsYYS","header":"lYMTn1kDJsbX","content":"Xn_vbbMYrkvT","button":"_3iMCxiGkZ_0q"};